import { Check } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { Port } from '../../types/models'
import { PortConfig, PortValueName } from '../../types/ports'
import { PortControl } from './PortControl'

/**
 * Base class for informative ports.
 */
export class InfoPortControl<P extends Port, C extends PortConfig> extends PortControl<P, C> {
  /**
   * Display a named value from a port.
   */
  valueView(title: string, name: PortValueName, checked: boolean = false): React.ReactNode {
    const value = typeof name === 'boolean'
      ? (name ? this.app.t('Yes') : this.app.t('No'))
      : (
          (this.port.values as Record<string, unknown>)[name] === undefined
            ? <>—</>
            : JSON.stringify((this.port.values as Record<string, unknown>)[name])
        )

    const mark = checked ? <Check color="success" sx={{ ml: '0.2rem', fontSize: '1rem' }}/> : <></>
    return (
      <Box>
        <Typography>{title}:</Typography>
        <Typography sx={{ ml: '2rem' }}>{value}{mark}</Typography>
      </Box>
    )
  }
}
